<template>
  <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <v-flex xs12 class="mt-3">
    <message :messages="messages"></message>
    <v-card>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 lg8>
              <v-layout row wrap>
                <v-flex lg6 xs12 v-if="newKey">
                  <v-text-field label="B2C Key*" data-vv-as="B2C Key" v-model="keyForm.b2cKey" :error-messages="errors.collect('b2cKey')" v-validate="'required|max:20|param'" data-vv-name="b2cKey"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-subheader class="queryLabel">B2C Key</v-subheader>
                  <div class="title">{{keyForm.b2cKey}}</div>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-autocomplete label="Default Intermediary*" data-vv-as="Default Intermediary" v-model="keyForm.intermediary" :items="intermediaryList" v-validate="'required'" item-text="label" item-value="value" data-vv-name="intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-checkbox label="Is Active" data-vv-as="Is Active" v-model="keyForm.isActive" data-vv-name="isActive" :error-messages="errors.collect('isActive')" hide-details></v-checkbox>
                </v-flex>
                <v-flex lg6 xs12>
                </v-flex>
                <v-flex lg6 xs12>
                  <cal-picker label="Effective Date*" data-vv-as="Effective Date" v-model="keyForm.dateOpened" v-validate="'required'" data-vv-name="dateOpened" :error-messages="errors.collect('dateOpened')"></cal-picker>
                </v-flex>
                <v-flex lg6 xs12>
                  <cal-picker label="Expiry Date" data-vv-as="Expiry Date" v-model="keyForm.dateClosed" data-vv-name="dateClosed" :error-messages="errors.collect('dateClosed')"></cal-picker>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field label="Payment Status URL*" data-vv-as="Payment Status URL" v-model="keyForm.paytStatusUrl" :error-messages="errors.collect('paytStatusUrl')" v-validate="'required|max:255|url'" data-vv-name="paytStatusUrl" persistent-hint hint="https://{URL}/status/"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field label="Query URL*" data-vv-as="Query URL" v-model="keyForm.queryUrl" :error-messages="errors.collect('queryUrl')" v-validate="'required|max:255|url'" data-vv-name="queryUrl" persistent-hint hint="https://{URL}/query/{id}"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field label="Member Activation URL*" data-vv-as="Member Activation URL" v-model="keyForm.membActivateUrl" :error-messages="errors.collect('membActivateUrl')" v-validate="'required|max:255|url'" data-vv-name="membActivateUrl" persistent-hint hint="https://{URL}/verify/{id}"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field label="Reset Password URL*" data-vv-as="Reset Password URL" v-model="keyForm.resetPassUrl" :error-messages="errors.collect('resetPassUrl')" v-validate="'required|max:255|url'" data-vv-name="resetPassUrl" persistent-hint hint="https://{URL}/reset-password/{id}"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" type="submit" @click.native="doValidateForm">
          {{newKey? 'Add B2C Key' : 'Update B2C Key'}}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-flex>
    <v-flex xs12 class="mt-3" v-if="newSection">
      <v-card>
        <v-card-title>
          <div>
            <div class="headline">B2C Key Products</div>
          </div>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.appId }}</td>
              <td class="text-xs-right">{{ props.item.product }}</td>
              <td class="text-xs-right">{{ formatDate(props.item.effDate) }}</td>
              <td class="text-xs-right">{{ formatDate(props.item.expDate !== null ? props.item.expDate : '') }}</td>
              <td class="text-xs-right">
                <table-action :rowData="props" :remove="checkAccess(['b2cKeyReview'])" @remove="doPromptRemove"></table-action>
              </td>
            </template>
          </v-data-table>
          <div class="pt-2">
            <v-btn color="primary" @click="doNewProduct()">
              Add B2C Key
              <v-icon right>mdi-key-plus</v-icon>
            </v-btn>
          </div>
          <v-dialog v-model="newProduct">
            <v-card>
              <v-card-title>
                Add B2C Key Product
                <v-spacer></v-spacer>
                <v-btn flat icon @click="newProduct = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex lg6 xs6>
                      <v-text-field label="B2C Key*" data-vv-scope="productForm" data-vv-as="B2C Key" v-model="keyForm.b2cKey" :error-messages="errors.collect('productForm.b2cKey')" v-validate="'required|max:20|param'" data-vv-name="b2cKey"></v-text-field>
                    </v-flex>
                    <v-flex lg6 xs6>
                      <v-autocomplete label="Category*" data-vv-scope="productForm" data-vv-as="appId" v-model="keyProductForm.appId" :items="appIdList" v-validate="'required'" item-text="label" item-value="value" data-vv-name="appId" :error-messages="errors.collect('productForm.appId')" @change="products(keyProductForm.appId)" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex lg6 xs6 >
                      <cal-picker label="Effective Date*" data-vv-scope="productForm" data-vv-as="Effective Date" v-model="keyProductForm.effDate" v-validate="'required'" data-vv-name="effDate" :error-messages="errors.collect('productForm.effDate')"></cal-picker>
                    </v-flex>
                    <v-flex lg6 xs6>
                      <v-autocomplete label="Product*" data-vv-scope="productForm" data-vv-as="Product" v-model="keyProductForm.product" :items="productList" v-validate="'required'" item-text="label" item-value="value" data-vv-name="product" :error-messages="errors.collect('productForm.product')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex lg6 xs6>
                      <cal-picker label="Expiry Date" data-vv-scope="productForm" data-vv-as="Expiry Date" v-model="keyProductForm.expDate" data-vv-name="expDate" :error-messages="errors.collect('expDate')"></cal-picker>
                    </v-flex>
                    <v-flex lg6 xs6></v-flex>
                    <v-btn color="primary" @click="newProduct = false">
                      Add
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
      </v-card>
    </v-flex>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import toDate from 'date-fns/toDate'
import { appIDDesc } from '@/const/underwriting'
export default {
  data() {
    return {
      newSection: false,
      breadcrumb: [],
      newProduct: false,
      newKey: false,
      loading: false,
      intermediaryList: [],
      productList: [],
      keyForm: {
        b2cKey: null,
        intermediary: null,
        paytStatusUrl: null,
        queryUrl: null,
        membActivateUrl: null,
        resetPassUrl: null,
        isActive: false,
        dateOpened: null,
        dateClosed: null
      },
      keyProductForm: {
        b2cKey: null,
        appId: null,
        product: null,
        effDate: null,
        expDate: null
      },
      headers: [
        { text: 'AppId', align: 'left', value: 'b2cKey' },
        { text: 'Product', align: 'right', value: 'product' },
        { text: 'Effective Date', align: 'right', value: 'effDate' },
        { text: 'Expiry Date', align: 'right', value: 'expDate' },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      menu: [],
      removeId: undefined,
      removeData: {}
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess',
      'derieveBreadcrumbByName'
    ]),
    title() {
      if (this.newKey) {
        return 'New B2C Key'
      } else {
        return 'Review B2C Key'
      }
    },
    b2cKeyProductList() {
      return this.$store.state.adminB2c.keys.b2cKeyProductList
    },
    appIdList() {
      const list = Object.freeze(appIDDesc)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    },
    intermediaryLists() {
      // AR: Fixed for SR5378 03-Mar-2020
      return this.$store.state.adminB2c.keys.intermediaryList
    }
  },
  methods: {
    async doInit() {
      if (!this.newKey) {
        // Review
        try {
          await this.reviewKey()
          this.fetchB2cKeyProduct()
        } catch (err) {
          console.log(err)
        }
      }
    },
    async products(appId) {
      const apiURI = this.$store.state.adminB2c.keys.menu.getProduct
      if (apiURI) {
        try {
          const expand = {
            inter: this.keyForm.intermediary,
            appId: appId
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.productList = result.data.data
          }
        } catch (error) {
          throw error
        }
      }
    },
    async reviewKey() {
      const apiURI = this.$store.state.adminB2c.keys.menu.getKey
      if (apiURI) {
        try {
          const expand = {
            id: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result
          if (data) {
            // key data init
            this.keyForm.b2cKey = data.b2cKey
            this.keyForm.intermediary = data.intermediary
            this.keyForm.paytStatusUrl = data.paytStatusUrl
            this.keyForm.queryUrl = data.queryUrl
            this.keyForm.membActivateUrl = data.membActivateUrl
            this.keyForm.resetPassUrl = data.resetPassUrl
            this.keyForm.isActive = data.isActive
            this.keyForm.dateOpened = data.dateOpened
            this.keyForm.dateClosed = data.dateClosed
            this.intermediaryList = data.intermediaryList
            // Extract menu
            this.menu = extractMenu(data._links)
          }
        } catch (error) {
          throw error
        }
      }
    },
    dointerList() {
      this.intermediaryList = this.intermediaryLists
    },
    // Find b2cKey Key Product
    async fetchB2cKeyProduct() {
      const apiUrl = this.$store.state.adminB2c.keys.menu.getKeyProduct
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            b2cKey: this.id,
            inter: this.keyForm.intermediary
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            this.totalItems = result.data.totalElements
            data.map((key) => {
              const convertKeyProduct = {
                b2cKey: key.b2cKey,
                appId: key.appId,
                product: key.product,
                effDate: toDate(key.effDate),
                expDate: toDate(key.expDate)
              }
              this.items.push(convertKeyProduct)
              this.loading = false
            })
          } else {
            this.items = []
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.loading = false
        this.errorMessage('Invalid API URL')
      }
    },
    doValidateForm() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newKey) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.adminB2c.keys.menu.createKey
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.post(apiURI, this.keyForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Redirect back to listing
            this.$router.push({ name: 'b2cKeys' })
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doUpdate() {
      if (this.menu.updateKey) {
        this.loading = true
        try {
          const result = await this.$http.post(this.menu.updateKey, this.keyForm)
          const { data } = result

          if (data) {
            // Show message
            this.message(data)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doPromptRemove(data) {
      if (data && data.item && data.item.b2cKey) {
        this.removeId = data.item.product
        this.removeData = data.item
        this.promptRemove = true
      }
    },
    async doRemove() {
      try {
        this.loading = true
        const result = await this.$http.post(this.deleteData)
        if (result.data) {
          this.message(result.data)

          // Refetch data
          this.fetchData(false)
        }
        this.loading = false
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.fullMessage(data)
        }
        this.loading = false
      }
    },
    async doNewProduct() {
      this.newProduct = true
      this.products()
    }
  },
  beforeMount() {
    if (this.id === 'new') {
      this.newKey = true
    }
    // Manual breadcrumb
    this.breadcrumb = this.derieveBreadcrumbByName('b2cKeys')
    this.breadcrumb.push({
      name: 'b2cKeyReview',
      text: this.title
    })
    Promise.all([this.dointerList()])
  },
  props: ['id'],
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
